/**
 * Class description
 *
 * Created: 2019-07-30
 * @author jonas
 */
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export interface PIXI_5_3_BitmapTextStyle {
    fontName:string;
    fontSize?:number;
    align?:string;
    tint?:number;
    letterSpacing?:number;
    maxWidth?:number;
}

export class WinterHoardTextStyles {

    public static FS_OUTRO_COUNT_UP:PIXI_5_3_BitmapTextStyle = {
        fontName:"BHCountUpNumber",
        fontSize:78,
        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static WIN_COUNT_UP:PIXI_5_3_BitmapTextStyle = {

        fontName:"BHCountUpNumber",
        fontSize:140,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static MULTIPLIER:PIXI_5_3_BitmapTextStyle = {

        fontName:"BHmultiplier",
        fontSize:140,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static MULTIPLIER_SYMBOL:PIXI_5_3_BitmapTextStyle = {
        fontName:"BHmultiplier",
        fontSize:50,
        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static MULTIPLIER_METER_M1:PIXI_5_3_BitmapTextStyle = {

        fontName:"BHmultiplier",
        fontSize:50,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static MULTIPLIER_METER:PIXI_5_3_BitmapTextStyle = {

        fontName:"BHmultiplier",
        fontSize:26,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    public static MULTIPLIER_METER_P:PIXI_5_3_BitmapTextStyle = {

        fontName:"BHmultiplier",
        fontSize:32,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static BIG_WIN_COUNT_UP:PIXI_5_3_BitmapTextStyle = {

        fontName:"NumbersWinCountUp",
        fontSize:156,

        tint:parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    public static FREESPIN_COUNTER:PIXI.TextStyle = new PIXI.TextStyle({
        fill:"#ffffff",
        fontFamily:"Open Sans",
        fontSize:50,
        fontStyle:FontStyle.NORMAL,
        fontWeight:FontWeight.BOLD
    });

    public static FREESPIN_PICK:PIXI.TextStyle = new PIXI.TextStyle({
        fill:"#ffffff",
        fontFamily:"Open Sans",
        fontSize:54,
        wordWrap:true,
        align:"center",
        wordWrapWidth:400,
        fontStyle:FontStyle.NORMAL,
        fontWeight:FontWeight.BOLD
    });


    public static DEFAULT_SCREEN_TEXT:PIXI.TextStyle = new PIXI.TextStyle({
        fill:"#ffffff",
        fontFamily:"Open Sans",
        fontSize:90,
        fontStyle:FontStyle.NORMAL,
        fontWeight:FontWeight.BOLD
    });

    public static FREESPINS_NUMBERS_TEXT:PIXI.TextStyle = new PIXI.TextStyle({
        fill:"#ffffff",
        fontFamily:"Open Sans",
        fontSize:180,
        fontStyle:FontStyle.NORMAL,
        fontWeight:FontWeight.BOLD
    });

    static BIG_WIN_TEXT:PIXI.TextStyle = new PIXI.TextStyle({
        dropShadow:true,
        dropShadowAlpha:1.0,
        dropShadowAngle:1.5,
        dropShadowBlur:5,
        dropShadowDistance:20,

        fill:[
            "#FFFF00",
            "#ffffff",
            "#ff8040",
            "#ffbe7d",
            "#572c00"
        ],
        fillGradientStops:[
            0.1,
            0.3,
            0.4,
            0.5,
            0.7
        ],
        miterLimit:2,
        stroke:"#ffa940",
        strokeThickness:7,

        fontFamily:"Open Sans",
        fontSize:180,
        fontStyle:FontStyle.NORMAL,
        fontWeight:FontWeight.BOLD,
        align:"center"
    });

}